import type { ProviderItem, StateResponse } from './api.js';

type ProviderStateMap = StateResponse['providers'];
type ProviderStateRow = ProviderStateMap[string];

function asFiniteNumber(value: unknown): number | null {
  if (typeof value === 'number') return Number.isFinite(value) ? value : null;
  if (typeof value === 'string') {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }
  return null;
}

export function normalizeSeverity(value: unknown): 0 | 1 | 2 | 3 {
  const num = asFiniteNumber(value);
  if (num === null) return 0;
  return Math.max(0, Math.min(3, Math.floor(num))) as 0 | 1 | 2 | 3;
}

function normalizeSeverityForActive(value: unknown): 1 | 2 | 3 {
  const num = asFiniteNumber(value);
  if (num === null) return 1;
  return Math.max(1, Math.min(3, Math.floor(num))) as 1 | 2 | 3;
}

export function resolveProviderState(
  state: ProviderStateMap | undefined,
  provider: Pick<ProviderItem, 'id' | 'slug'>,
): ProviderStateRow | undefined {
  if (!state) return undefined;
  return state[provider.id] ?? state[provider.slug];
}

export function getProviderSeverityTone(
  state: ProviderStateMap | undefined,
  provider: Pick<ProviderItem, 'id' | 'slug'>,
): 0 | 1 | 2 | 3 {
  return normalizeSeverity(resolveProviderState(state, provider)?.severity ?? 0);
}

export function getProviderActiveTone(
  state: ProviderStateMap | undefined,
  provider: Pick<ProviderItem, 'id' | 'slug'>,
): 1 | 2 | 3 {
  return normalizeSeverityForActive(resolveProviderState(state, provider)?.severity ?? 0);
}
